"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfListProfileSpecialtyDto = instanceOfListProfileSpecialtyDto;
exports.ListProfileSpecialtyDtoFromJSON = ListProfileSpecialtyDtoFromJSON;
exports.ListProfileSpecialtyDtoFromJSONTyped = ListProfileSpecialtyDtoFromJSONTyped;
exports.ListProfileSpecialtyDtoToJSON = ListProfileSpecialtyDtoToJSON;
exports.ListProfileSpecialtyDtoToJSONTyped = ListProfileSpecialtyDtoToJSONTyped;
const AssessmentStatus_1 = require("./AssessmentStatus");
const CertificationStatus_1 = require("./CertificationStatus");
/**
 * Check if a given object implements the ListProfileSpecialtyDto interface.
 */
function instanceOfListProfileSpecialtyDto(value) {
    if (!('specialtyCode' in value) || value['specialtyCode'] === undefined)
        return false;
    if (!('assessmentStatus' in value) || value['assessmentStatus'] === undefined)
        return false;
    if (!('certificationStatus' in value) || value['certificationStatus'] === undefined)
        return false;
    return true;
}
function ListProfileSpecialtyDtoFromJSON(json) {
    return ListProfileSpecialtyDtoFromJSONTyped(json, false);
}
function ListProfileSpecialtyDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'specialtyCode': json['specialtyCode'],
        'assessmentStatus': (0, AssessmentStatus_1.AssessmentStatusFromJSON)(json['assessmentStatus']),
        'certificationStatus': (0, CertificationStatus_1.CertificationStatusFromJSON)(json['certificationStatus']),
    };
}
function ListProfileSpecialtyDtoToJSON(json) {
    return ListProfileSpecialtyDtoToJSONTyped(json, false);
}
function ListProfileSpecialtyDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'specialtyCode': value['specialtyCode'],
        'assessmentStatus': (0, AssessmentStatus_1.AssessmentStatusToJSON)(value['assessmentStatus']),
        'certificationStatus': (0, CertificationStatus_1.CertificationStatusToJSON)(value['certificationStatus']),
    };
}
//# sourceMappingURL=ListProfileSpecialtyDto.js.map